import formFields from './html5/forms/all.forms.js';

export default {
  "1-2-3":{
    processNo: "1-2",
    pageNo: "1",
    fields: formFields['ExistingBDOPartner']
  },
  "1-3-3": {
    processNo: "1-3",
    pageNo: "1",
    fields: formFields['NewBDOPartnerSolePropA'],
  },
  "1-3-5": {
    processNo: "1-3",
    pageNo: "5",
    fields: ['idNumber', 'idType', 'frontId', 'backId', ],
  },
  "1-3-14": {
    processNo: "1-3",
    pageNo: "14",
    fields: ['signature', ],
  },
  "1-3-16": {
    processNo: "1-3",
    pageNo: "16",
    fields: formFields['NewBDOPartnerSolePropJ'],
  },
  "1-3-17": {
    processNo: "1-3",
    pageNo: "17",
    fields: formFields['NewBDOPartnerSolePropK'],
  },
  "1-3-18": {
    processNo: "1-3",
    pageNo: "18",
    fields: formFields['NewBDOPartnerSolePropL'],
  },
  // "1-3-19": {
  //   processNo: "1-3",
  //   pageNo: "19",
  //   fields: formFields['NewBDOPartnerSolePropL'],
  // },
  "1-3-19": {
    processNo: "1-3",
    pageNo: "19",
    fields: ['busiDocPhoto'],
  },  
  "1-3-21": {
    processNo: "1-3",
    pageNo: "21",
    fields: ['storePhoto', ],
  },
  "1-3-22": {
    processNo: "1-3",
    pageNo: "22",
    fields: formFields['NewBDOPartnerSolePropO'],
  },
  "1-3-24": {
    processNo: "1-3",
    pageNo: "24",
    fields: ['settleAccountType', 'settleAccountNum'],
  },
  "1-4-2":{
    processNo: "1-4",
    pageNo: "1",
    fields: formFields['NewBDOPartnerCorp']
  },
  "2-1-3":{
    processNo: "2-1",
    pageNo: "1",
    fields: formFields['ExistingBDOMerchant']
  },
  "2-2-4":{
    processNo: "2-2",
    pageNo: "1",
    fields: formFields['NewMerchantIndividualA']
  },
  "2-2-7":{
    processNo: "2-2",
    pageNo: "7",
    fields: formFields['NewMerchantIndividualB']
  },
  "2-2-8":{
    processNo: "2-2",
    pageNo: "8",
    fields: formFields['NewMerchantIndividualC']
  },
  "2-2-9":{
    processNo: "2-2",
    pageNo: "12",
    fields: formFields['NewMerchantIndividualD']
  },
  "2-2-14":{
    processNo: "2-2",
    pageNo: "14",
    fields: []
  },
  "2-2-18":{
    processNo: "2-2",
    pageNo: "18",
    fields: []
  },
  "2-2-19":{
    processNo: "2-2",
    pageNo: "19",
    fields: formFields['NewMerchantIndividualH']
  },
  "2-2-20":{
    processNo: "2-2",
    pageNo: "20",
    fields: formFields['NewMerchantIndividualI']
  },
  "2-2-21":{
    processNo: "2-2",
    pageNo: "21",
    fields: formFields['NewMerchantIndividualJ']
  },
  "2-2-22":{
    processNo: "2-2",
    pageNo: "22",
    fields: []
  },
  "2-2-24":{
    processNo: "2-2",
    pageNo: "24",
    fields: []
  },
  "2-3-2":{
    processNo: "2-3",
    pageNo: "1",
    fields: formFields['NewMerchantSolePropA']
  },
  "2-3-5":{
    processNo: "2-3",
    pageNo: "5",
    fields: formFields['NewMerchantSolePropB']
  },
  "2-3-6":{
    processNo: "2-3",
    pageNo: "6",
    fields: formFields['NewMerchantSolePropC']
  },
  "2-3-7":{
    processNo: "2-3",
    pageNo: "10",
    fields: formFields['NewMerchantSolePropD']
  },
  "2-3-12":{
    processNo: "2-3",
    pageNo: "12",
    fields: []
  },
  "2-3-14":{
    processNo: "2-3",
    pageNo: "14",
    fields: []
  },
  "2-3-16":{
    processNo: "2-3",
    pageNo: "16",
    fields: formFields['NewMerchantSolePropH']
  },
  "2-3-17":{
    processNo: "2-3",
    pageNo: "17",
    fields: formFields['NewMerchantSolePropI']
  },
  "2-3-18":{
    processNo: "2-3",
    pageNo: "18",
    fields: formFields['NewMerchantSolePropJ']
  },
  "2-3-19":{
    processNo: "2-3",
    pageNo: "19",
    fields: []
  },
  "2-3-21":{
    processNo: "2-3",
    pageNo: "21",
    fields: []
  },
  "2-3-23":{
    processNo: "2-3",
    pageNo: "23",
    fields: []
  },
  "2-4-1":{
    processNo: "2-4",
    pageNo: "1",
    fields: formFields['NewMerchantCorpA']
  },
}
